import styled from "@emotion/styled";
import React from "react";
import useLanguage from "@src/hooks/useLanguage";

interface IProps {
  color?: string;
}

const Root = styled.a<IProps>`
  display: flex;
  font-family: Montserrat, sans-serif;
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 24px;
  color: ${({ color }) => color ?? "#2934d0"};
  cursor: pointer;
  text-decoration: none;
`;

const Logo: React.FC<IProps> = ({ color }) => {
  const dictionary = useLanguage();
  return (
    <Root href="/" color={color}>
      {dictionary.kasanie}.
    </Root>
  );
};

export default Logo;
